import {
  Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import BillingReportsService from "../../../Services/Reports/BillingReportsService";
import Snackbar from '../../Snacbar'
import { getUserId } from '../../Utils/Common';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: '1px solid black',
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  border: '1px solid black',
  height: "100",
}));

function MultipleBillDownload() {
  const mystyle = {
    border: " 1px solid black",
    width: "10rem",
    fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",
    fontFamily: 'Times New Roman',
  };
  const mystyle2 = {
    fontWeight: "bolder",
    color: "red",
    textAlign: "center",
    fontFamily: 'Times New Roman',
  };
  ///hidden
  const [BillFormatHidden, setBillFormatHidden] = useState(true);
  const [statenamehidden, setstatenamehidden] = useState(true);
  ///warnings
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  ///setdetails
  const [radiovalue, setradiovalue] = useState("1");
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [FilteredDetails, setFilteredDetails] = useState([])

  // const [details4, setdetails4] = useState([]);
  const [multipleBillValues, setmultipleBillValues] = useState({
    Billfrom: '',
    Billto: '',
    printto: '-1',
    stateName: '-1',
    ///summary
    totalJobno: '0',
    taxableValue: '0.00',
    cgstAmt: '0.00',
    sgstAmt: '0.00',
    igstaAmt: '0.00',
    totalAmt: '0.00',
  });
  const Billfromhandlechange = (e) => {
    setmultipleBillValues({ ...multipleBillValues, Billfrom: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const Billtohandlechange = (e) => {
    setmultipleBillValues({ ...multipleBillValues, Billto: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const printtohandlechange = (e) => {
    setmultipleBillValues({ ...multipleBillValues, printto: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const statehandlechange = (e) => {
    setmultipleBillValues({ ...multipleBillValues, stateName: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const radiovalueOnchange = (e) => {
    if (radiovalue === '1') {
      setBillFormatHidden(false)
      setstatenamehidden(false)
    } else {
      setBillFormatHidden(true)
      setstatenamehidden(true)
    }
    document.getElementById('Billfrom').focus();
    setmultipleBillValues({
      ...multipleBillValues, Billfrom: '', Billto: '', stateName: '', printto: '',
      totalJobno: '0', taxableValue: '0.00', cgstAmt: '0.00', sgstAmt: '0.00', igstaAmt: '0.00', totalAmt: '0.00',
    })
    setdetails3([]);
    setradiovalue(e.target.value)
  };
  ///
  const handleClose = () => {
    setOpen(false)
  }
  //clearvalues====================>
  const clearSummary = () => {
    setmultipleBillValues({ ...multipleBillValues, totalJobno: '0', taxableValue: '0.00', cgstAmt: '0.00', sgstAmt: '0.00', igstaAmt: '0.00', totalAmt: '0.00', })
  }
  ///
  const validation = () => {
    if (multipleBillValues.Billfrom !== '') {
      if (multipleBillValues.Billto !== '') {
        return true;
      } else {
        setMessage("Enter the " + JobillTo_labelchange() + '..!!');
        setseverit('warning');
        setOpen(true);
        document.getElementById('Billto').focus();
      }
    } else {
      setMessage("Enter the " + JobillFrm_labelchange() + '..!!');
      setseverit('warning');
      setOpen(true);
      document.getElementById('Billfrom').focus();
    }
    return false;
  }
  ///lablechange===============>

  const JobillFrm_labelchange = () => {
    if (radiovalue === "1") {
      return "From JobNo";
    } else if (radiovalue === "2") {
      return "From BillNo";
    }
  };
  const JobillTo_labelchange = () => {
    if (radiovalue === "1") {
      return "To JobNo";
    } else if (radiovalue === "2") {
      return "To BillNo";
    }
  };
  ///getFunctions=================>
  const getBillPrintTo = () => {
    BillingReportsService.getBillPrintTo().then(res => {
      setdetails1(res.data);
    })
  }
  const getDeliveryStateName = () => {
    BillingReportsService.getDeliveryStateName().then(res => {
      setdetails2(res.data);
    })
  }
  ///buttonsOperation==============>
  const ShowButtonOnClick = () => {
    if (validation() === true) {
      clearSummary();
      setdetails3([])
      var flagbill, deliveryStateName = '';
      if (radiovalue === '1') {
        flagbill = 3;
        deliveryStateName = '-1'
      } else {
        flagbill = 2;
        deliveryStateName = multipleBillValues.stateName;
      }
      let details = {
        flagbill: flagbill, deliveryStateName: deliveryStateName, createdBy: getUserId(),
        fromBill: multipleBillValues.Billfrom, toBill: multipleBillValues.Billto
      }
      BillingReportsService.showMultipleBill(details).then(res => {
        const data = res.data;
        details = data.map((item) => item);
        if (!details[0]) {
          setMessage('No Data Found')
          setseverit('warning')
          setOpen(true)
        } else {
          var totalJob = 0, taxableAmt = 0, cgst_Amt = 0, sgst_Amt = 0, igst_Amt = 0, totalBill_Amt = 0;
          for (let i = 0; i < details.length; i++) {
            totalJob = i + 1;
            taxableAmt += details[i].billAmount;
            cgst_Amt += details[i].cgstAmt;
            sgst_Amt += details[i].sgstAmt;
            igst_Amt += details[i].igstAmt;
            totalBill_Amt += details[i].totalBillAmount;
          }
          setmultipleBillValues({
            ...multipleBillValues, totalJobno: totalJob, taxableValue: taxableAmt,
            cgstAmt: cgst_Amt.toFixed(2), sgstAmt: sgst_Amt.toFixed(2), igstaAmt: igst_Amt.toFixed(2), totalAmt: totalBill_Amt.toFixed(2),
          });
          setdetails3(res.data);
          setFilteredDetails(res.data)
        }
      })
    }
  }
  ///
  const RefreshBtnOnClick = () => {
    setradiovalue('1')
    setBillFormatHidden(true)
    setstatenamehidden(true);
    setmultipleBillValues({
      ...multipleBillValues, Billfrom: '', Billto: '', stateName: '',
      totalJobno: '0', taxableValue: '0.00', cgstAmt: '0.00', sgstAmt: '0.00', igstaAmt: '0.00', totalAmt: '0.00',
    })
    document.getElementById('Billfrom').focus();
    setFilteredDetails([])
    setdetails3([]);
  }
  const DownloadBillOnClick = () => {
    var delvryStateName, flgbill, billby = '';
    if (validation() === true) {
      if (radiovalue === '1') {
        delvryStateName = '';
        flgbill = 1;
      } else {
        delvryStateName = multipleBillValues.stateName;
        flgbill = 2;
      }
      if (multipleBillValues.printto === 'IMPORTER' || multipleBillValues.printto === 'EXPORTER') {
        billby = '1'
      } else {
        billby = '2'
      }
      let details = {
        deliveryStateName: delvryStateName, flagbill: flgbill, billBy: billby, createdBy: getUserId(),
        fileName: multipleBillValues.Billfrom + " " + multipleBillValues.Billto, fromBill: multipleBillValues.Billfrom, toBill: multipleBillValues.Billto
      }
      BillingReportsService.MultipleInvoiceBillPdfPrint(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank");
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");


      })
    }
  }

  //serach table
  const jobnoSrch = () => {
    return <input style={{ width: '60px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { jobnoSearchOnchange(e.target.value) }} />
  }
  const gstBillNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { billnoSearchOnchange(e.target.value) }} />
  }
  const importerSrch = () => {
    return <input style={{ width: '90px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { impNameSearchOnchange(e.target.value) }} />
  }
  const modeSrch = () => {
    return <input style={{ width: '60px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { modeSearchOnchange(e.target.value) }} />
  }
  const BillpaidDateSrch = () => {
    return <input style={{ width: '100px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { dateSearchOnchange(e.target.value) }} />
  }
  const jobnoSearchOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.consignmentId.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const billnoSearchOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.invoiceNo.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const impNameSearchOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.iecName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const modeSearchOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.transitMode.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const dateSearchOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.billPaidDate.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  useEffect(() => {
    getBillPrintTo();
    getDeliveryStateName();
  }, []);
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  return (
    <div>
      <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
      <Home />
      <div style={{ paddingLeft: '100px' }}>
        <ItemPap >
          <Grid container>
            <Grid item xs={8}>
              <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '22px', marginTop: '1%', marginBottom: '1%', }}><center>MULTIPLE BILL DOWNLOAD</center></div>
              <Row>
                <Col>
                  <Form.Check style={mystyle1} checked={radiovalue === '1'} onChange={radiovalueOnchange} inline label='Job No' value={'1'} type='radio' />
                  <Form.Check style={mystyle1} checked={radiovalue === '2'} onChange={radiovalueOnchange} inline label='GST BillNo' value={'2'} type='radio' />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={2}>
                  <label style={mystyle1}>{JobillFrm_labelchange()}</label>
                </Col>
                <Col xs={3}>
                  <Form.Control size="sm" id='Billfrom' type="text" style={mystyle} value={multipleBillValues.Billfrom} onChange={Billfromhandlechange} />
                </Col>
                <Col xs={2}>
                  <label style={mystyle1}>{JobillTo_labelchange()}</label>
                </Col>
                <Col xs={2}>
                  <Form.Control size="sm" id='Billto' type="text" style={mystyle} value={multipleBillValues.Billto} onChange={Billtohandlechange} />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={2}>
                  <label style={mystyle1}>Bill PrintTo</label>
                </Col>
                <Col xs={3}>
                  <Form.Select size="sm" style={mystyle} value={multipleBillValues.printto} onChange={printtohandlechange}>
                    <option value='-1'> ---SELECT--- </option>
                    {details1.map(trns => (
                      <option value={trns.billPaidTo}>{trns.billPaidTo}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col xs={2}>
                  <label hidden={statenamehidden} style={mystyle1}>StateName</label>
                </Col>
                <Col xs={2}>
                  <Form.Select hidden={statenamehidden} size="sm" style={mystyle} value={multipleBillValues.stateName} onChange={statehandlechange}>
                    <option value={'-1'}>---select---</option>
                    {details2.map(trns => (
                      <option value={trns.stateCode}>{trns.deliveryStateName}</option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
              <div hidden={BillFormatHidden}>
                <div><Form.Label style={mystyle2}>Bill No Format:</Form.Label>
                  <Form.Label style={{ color: 'black', marginTop: '2%', fontWeight: 'bold' }}>For EX: NGDL/19-20/20,For Input:20(text after 2ndslash)</Form.Label></div>
              </div>
              <Row className="mt-3">
                <Col lg={3}></Col>
                <Col lg={6}>
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="primary" size="sm" onClick={ShowButtonOnClick}>Show</Button>{" "}
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="secondary" size="sm" onClick={RefreshBtnOnClick}>Refresh</Button>{" "}
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="success" size="sm" onClick={DownloadBillOnClick}>Download Bill Copy</Button>
                </Col>
                <Col lg={3}></Col>
              </Row>
            </Grid>
            <Grid item xs={4}>
              <ItemPap1>
                <Typography color={"darkblue"} fontWeight={"bolder"} variant={"h6"} style={{ marginTop: "-1rem" }}>Summary</Typography>
                <Row>
                  <Col xs={3} ><Form.Label style={{
                    fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder",
                  }}>TotalJobNo</Form.Label></Col>
                  <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                  <Col><Form.Label style={{ justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{multipleBillValues.totalJobno}</Form.Label></Col>
                </Row>
                <Row>
                  <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TaxableValue</Form.Label></Col>
                  <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                  <Col><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{multipleBillValues.taxableValue}</Form.Label></Col>
                </Row>
                <Row>
                  <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>CGSTAmount</Form.Label></Col>
                  <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                  <Col><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{multipleBillValues.cgstAmt}</Form.Label></Col>
                </Row>
                <Row>
                  <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>SGSTAmount</Form.Label></Col>
                  <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                  <Col><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{multipleBillValues.sgstAmt}</Form.Label></Col>
                </Row>
                <Row>
                  <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>IGSTAmount</Form.Label></Col>
                  <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                  <Col><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{multipleBillValues.igstaAmt}</Form.Label></Col>
                </Row>
                <Row>
                  <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalBilling Amount</Form.Label></Col>
                  <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                  <Col><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{multipleBillValues.totalAmt}</Form.Label></Col>
                </Row>
              </ItemPap1>
            </Grid>
          </Grid>
          <TableContainer sx={{ height: 340 }} className="mt-1">
            <Table stickyHeader className="table table-bordered">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>SlNo</StyledTableCell>
                  <StyledTableCell>JobNo {jobnoSrch()}</StyledTableCell>
                  <StyledTableCell>GST_Bill No{gstBillNoSrch()}</StyledTableCell>
                  <StyledTableCell>ImporterName {importerSrch()}</StyledTableCell>
                  <StyledTableCell>ForwarderName</StyledTableCell>
                  <StyledTableCell>Mode {modeSrch()}</StyledTableCell>
                  <StyledTableCell>TotalPkg</StyledTableCell>
                  <StyledTableCell>Gross_Wt</StyledTableCell>
                  <StyledTableCell>Bill_Paid_By</StyledTableCell>
                  <StyledTableCell>Bill_Paid_Date {BillpaidDateSrch()}</StyledTableCell>
                  <StyledTableCell>TaxableValue</StyledTableCell>
                  <StyledTableCell>CGST_Amount</StyledTableCell>
                  <StyledTableCell>SGST_Amount</StyledTableCell>
                  <StyledTableCell>IGST_Amount</StyledTableCell>
                  <StyledTableCell>Total_BillAmount</StyledTableCell>
                  <StyledTableCell>MAWB/MBL</StyledTableCell>
                  <StyledTableCell>HAWB/HBL</StyledTableCell>
                  <StyledTableCell>ContainerNo</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((trns, index) => (
                    <TableRow hover key={trns.serialNumber}>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }} component='th' scope="row">{trns.serialNumber}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentId}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNo}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.iecName}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.fwdName}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.transitMode}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.noOfPkg}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.grNetWeight}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billPaidBy}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billPaidDate}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billAmount}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cgstAmt}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sgstAmt}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igstAmt}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalBillAmount}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawbNo}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawbNo}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.containerNo}</StyledTableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            showFirstButton
            showLastButton
            component='div'
            count={FilteredDetails.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onChangeRowsPerpage={handleChangeRowsPerPage}
          />
        </ItemPap>
      </div>
    </div >
  );
}

export default MultipleBillDownload;
